import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api';
import { Card, formatDate, Page, State } from '../components';
interface Lead {
  id: string;
  name?: string;
  email?: string;
  phone?: string;
  visitorMessage?: string;
  consentedAt: string;
  createdAt: string;
}
export function LeadsPage() {
  const query = useQuery({
    queryKey: ['leads'],
    queryFn: () => api<{ data: Lead[] }>('/api/v1/leads'),
  });
  return (
    <Page title="Leads" description="Only explicitly consented contact details appear here.">
      <State loading={query.isLoading} error={query.error} empty={query.data?.data.length === 0}>
        <div className="card table-scroll">
          <table>
            <thead>
              <tr>
                <th>Contact</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Consent</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {query.data?.data.map((lead) => (
                <tr key={lead.id}>
                  <td>{lead.name ?? 'Not provided'}</td>
                  <td>{lead.email ?? '—'}</td>
                  <td>{lead.phone ?? '—'}</td>
                  <td>{formatDate(lead.consentedAt)}</td>
                  <td>
                    <Link to={`/leads/${lead.id}`}>View</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </State>
    </Page>
  );
}
export function LeadDetailPage() {
  const { id } = useParams();
  const query = useQuery({
    queryKey: ['lead', id],
    queryFn: () => api<Lead>(`/api/v1/leads/${id}`),
  });
  return (
    <Page
      title="Lead detail"
      actions={
        <Link className="button" to="/leads">
          Back
        </Link>
      }
    >
      <State loading={query.isLoading} error={query.error}>
        {query.data && (
          <Card className="record">
            <dl>
              <dt>Name</dt>
              <dd>{query.data.name ?? 'Not provided'}</dd>
              <dt>Email</dt>
              <dd>{query.data.email ?? 'Not provided'}</dd>
              <dt>Phone</dt>
              <dd>{query.data.phone ?? 'Not provided'}</dd>
              <dt>Consent recorded</dt>
              <dd>{formatDate(query.data.consentedAt)}</dd>
              <dt>Visitor message</dt>
              <dd>{query.data.visitorMessage ?? 'Not provided'}</dd>
            </dl>
          </Card>
        )}
      </State>
    </Page>
  );
}
